import { createAsyncThunk } from "@reduxjs/toolkit";
import { MixService } from "../../services/MixService";
import { AxiosError } from "axios";
import { MixInterface } from "../../entities/Mix";

export const fetchMixesByWebshop = createAsyncThunk<
  MixInterface[],
  string | number,
  { rejectValue: AxiosError }
>("mix/fetchAllByFuchs", async (id: string | number, { rejectWithValue }) => {
  try {
    const response = await MixService.getMixesByWebshop(id);
    return response;
  } catch (e: any) {
    return rejectWithValue(e.message as AxiosError);
  }
});
